import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import Folders from "./Folders";
import FolderSkeleton from "./FolderSkeleton";
import SearchFIles from "./SearchFIles";
import { useDispatch, useSelector } from "react-redux";
import {
  handleDisableFilter,
  setBlobFilterStates,
} from "~/Pages/Process/actions/attachmentsSlice";

const TypeFileDocuments = () => {
  const { id, service_id, type } = useParams();
  const { blobFilterStates } = useSelector((state) => state.attachments);
  const dispatch = useDispatch();

  const {
    states,
    handleClickType,
    fileName,
    setFileName,
    rows,
    first,
    onPageChange,
  } = useFileDocuments({
    id,
    service_id,
    type,
  });
  useEffect(() => {
    dispatch(setBlobFilterStates({}));
  }, []);
  useEffect(() => {
    dispatch(handleDisableFilter(!states?.folders?.length));
  }, [states?.folders]);
  return (
    <>
      {states.loading ? (
        blobFilterStates?.selectedItems?.length ? null : (
          <FolderSkeleton />
        )
      ) : (
        <>
          {!states.folders || blobFilterStates?.selectedItems?.length ? (
            <>
              {blobFilterStates?.selectedItems?.length ? (
                <p className="document-sub-heading"> Matching Files</p>
              ) : null}
              <SearchFIles
                fileName={fileName}
                setFileName={setFileName}
                additionaltag={{ entity: [states?.entity_detail?.name] }}
                states={states}
                first={first}
                rows={rows}
                onPageChange={onPageChange}
                isRootFolder={true}
              />
            </>
          ) : (
            <div className="service-folder-container">
              {states?.folders?.length > 0 && (
                <p className="document-sub-heading"> Folders</p>
              )}
              {states.loading ? (
                <FolderSkeleton />
              ) : (
                <Folders
                  folders={states?.folders}
                  onFolderClick={handleClickType}
                />
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TypeFileDocuments;
